import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Col, Row, Button, Spinner } from 'react-bootstrap';
import axios from 'helpers/api';
import { toast } from 'react-toastify';

const HcpModal = ({ show, setShow, handleHcpModalValue }) => {
    const [hcpModalData, setHcpModalData] = useState("");
    const [loading, setLoading] = useState(false);

    const handleCallbackSubmit = async (e) => {
        e.preventDefault();
        const trimmedVal = hcpModalData.trim();
        if (!trimmedVal) {
            toast.warning("Please enter a speciality name");
            return;
        }

        let tokenStr = localStorage.getItem("accessToken");
        setLoading(true);

        try {
            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/doctors/add-doctor-speciality`,
                { speciality: trimmedVal, is_active: 1 },
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );

            if (data.status) {
                toast.success(data.message || "Doctor Speciality added successfully");
                setHcpModalData("");
                setShow(false);
                if (handleHcpModalValue) {
                    await handleHcpModalValue(trimmedVal, data);
                }
            } else {
                toast.info(data.message || "Error while adding doctor speciality");
            }
        } catch (error) {
            console.error("Error submitting doctor speciality:", error);
            toast.error("Error submitting doctor speciality");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setHcpModalData("");
        setShow(false);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="md"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    Add Speciality
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-body-tertiary p-4">
                <Form onSubmit={handleCallbackSubmit} name="specialitymodalform">
                    <Row className="align-items-end">
                        <Col xs={8}>
                            <Form.Group>
                                <Form.Label className="required">Speciality Name</Form.Label>
                                <Form.Control
                                    value={hcpModalData}
                                    name="specialitytextbox"
                                    onChange={e => setHcpModalData(e.target.value)}
                                    type="text"
                                    placeholder="Enter Speciality"
                                    required
                                    autoFocus
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={4}>
                            <Button
                                type="submit"
                                variant="primary"
                                name="btnspecialitymodalsubmit"
                                className="w-100"
                                disabled={loading || !hcpModalData.trim()}
                            >
                                {loading ? <Spinner animation="border" size="sm" /> : "Add"}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

HcpModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    handleHcpModalValue: PropTypes.func
};

export default HcpModal;

